window.queue = []

function App(data) {
	this.data = data || {}
    this.init()
}

App.modules = []

App.addModule = function(module) {
    this.modules.push(module)
}

App.prototype = {
	
    constructor: App,

    initialized: false,

    init: function() {
    	
        if (this.get('app.is_developer_mode')) {
            console.log(this.data)
        }

        App.modules.forEach(module => {
            
            try {
			    module.call(this, this)
		    }
		    catch (e) {
			    this.logException(e)
		    }
        })

        this.initialized = true

        dispatchEvent(new Event('mage:initialized'))

        addEventListener('load', () => {

            boundCallbackHandler = fn => {
            
                try {
			        fn.call(this, this)
		        }
		        catch (e) {
			        this.logException(e)
		        }
            }

        	window.queue.forEach(boundCallbackHandler)
        	
        	window.queue = {
        		push: boundCallbackHandler
        	}
            
            this.dispatchEvent('loaded')
        })
    },

    dispatchEvent(type, params) {

        if (!Array.isArray(params)) {
            var params = [params]
        }

        var event = new CustomEvent('mage:' + type, {detail: params})

        if (this.initialized) {
            dispatchEvent(event)
        }
        else {
            addEventListener('mage:initialized', () => {
                dispatchEvent(event)
            })
        }

        return this
    },
    
    on: function(type, callback) {

        addEventListener('mage:' + type, event => {

            try {
                callback.apply(this, event.detail)
            }
            catch (e) {
                this.logException(e)
            }
        })

        return this
    },

    onConsent: function(type, cb) {
        cm && cm.addCallback(type, cb) || cb()
    },

    log: function(msg, level) {

    	if (!msg) {
    		return
    	}

    	if (typeof(msg) === 'object') {
    		msg = JSON.stringify(msg)
    	}

        const params = new URLSearchParams({
            message: msg,
    	    level: level,
    	    form_key: this.get('app.session.form_key')
        })

    	fetch(this.getUrl('theme/data/log') + '?' + params.toString())
        
        return this
    },
    
    logException: function(e) {
    	
    	if (!e) {
    		return this
    	}
    	
    	if (this.get('app.is_developer_mode')) {
    		console.error(e)
    	}
    	
    	this.log(e.toString(), 3)

        this.dispatchEvent('exception', e)
    },

    get: function(path, defaultValue) {
    	
    	var data = this.data,
    		path = path || '___'

    	path.split('.').forEach(node => {

    		if (!data[node]) {
    			data = defaultValue || false
    			return
    		}
    		
    		data = data[node]
        })

    	return data
    },
    
    set: function(path, key, value) {
    	
    	var data = this.data,
    		key = key.toString()
    	
    	path.split('.').forEach(node => {

    		if (!data[node]) {
    			data[node] = {}
    		}
    		
    		data = data[node]
        })
    	
    	if (typeof(data) == 'object') {
    		data[key] = value
    	}
    	else {
    		throw Exception()
    	}
    	
    	return this
    },
    
    getConfig: function(path) {
    	return this.get('app.config.'+ path, '')
    },
    
    getConfigFlag: function(path) {
    	return this.getConfig(path) === '1'
    },
    
    getUrl: function(path) {
    	
    	if (location.href.indexOf('mia-moebel.ch/acryl/') != -1) {
    		path = 'acryl/' + path
    	}
    	
    	return location.protocol +'//'+ location.hostname +'/'+ path
    },

    loadScript: function(url, onload) {
        
        const script = document.createElement("script")

        script.async = true
        script.src = url

        if (onload) {
            script.onload = onload
        }

        const r = document.getElementsByTagName("script")[0]

        r.parentNode.insertBefore(script, r)

        return script
    },

    round: function(x, decimals=2) {
        return parseFloat(x).toFixed(decimals)
    }
};

// Bootstrap
var BS = {
	
	screen_sm_min: 768,
	screen_md_min: 992,
	screen_lg_min: 1200,
	
	viewport_width: function() {
		return $ && $(window).width()
	},
	
	isScreenXs: function() {
		return BS.viewport_width() < BS.screen_sm_min
	},
	
	isScreenSm: function() {
		var width = BS.viewport_width()
		return width >= BS.screen_sm_min && width < BS.screen_md_min
	},
	
	isScreenSmMin: function() {
		return BS.viewport_width() >= BS.screen_sm_min
	},
	
	isScreenMd: function() {
		var width = BS.viewport_width()
		return width >= BS.screen_md_min && width < BS.screen_lg_min
	},
	
	isScreenMdMin: function() {
		return BS.viewport_width() >= BS.screen_md_min
	},
	
	isScreenLg: function() {
		return BS.isScreenLgMin()
	},
	
	isScreenLgMin: function() {
		return BS.viewport_width() >= BS.screen_lg_min
	}
}
